(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5019],{

/***/ 9011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ o; },
/* harmony export */   "h": function() { return /* binding */ n; }
/* harmony export */ });
/* harmony import */ var _utils_can_use_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53586);
var o=(e=>(e.mobile="mobile",e.desktop="desktop",e))(o||{});function t(){let e=!1;return function(i){(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(i)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(i.substr(0,4)))&&(e=!0)}(navigator.userAgent||navigator.vendor||window.opera),e}const m=_utils_can_use_dom_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z&&t()?"mobile":"desktop";function n(){return m}
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 80581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ t; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
function t(){return (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({addOffset:()=>{},setOffset:()=>{},dragState:null,defaultBounds:{top:0,bottom:0,left:0,right:0},setSlideIndex:()=>{},nextSlide:()=>{},prevSlide:()=>{},slideIndex:0,maxSlideIndex:0,enableDrag:!0})}
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 68971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ PageViewAnalytics; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _unlikelystudio_react_ecommerce_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13711);



function PageViewAnalytics(param) {
    var template = param.template;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var pathname = "".concat(router === null || router === void 0 ? void 0 : router.locale).concat(router === null || router === void 0 ? void 0 : router.pathname);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_unlikelystudio_react_ecommerce_hooks__WEBPACK_IMPORTED_MODULE_2__/* .PageViewAnalytics */ .WA, {
        template: template,
        pathname: pathname
    });
}


/***/ }),

/***/ 45336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UI_GridList; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react-polyglot/lib/index.js
var lib = __webpack_require__(14408);
// EXTERNAL MODULE: ./src/@types/text-preset.ts
var text_preset = __webpack_require__(95348);
// EXTERNAL MODULE: ./src/@types/text-styling.ts
var text_styling = __webpack_require__(36575);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-abstract-components/dist/es/components/Link/index.js
var Link = __webpack_require__(13200);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-hooks/dist/es/useIsHover/index.js
var useIsHover = __webpack_require__(61356);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-hooks/dist/es/useDeviceType/index.js
var useDeviceType = __webpack_require__(9011);
// EXTERNAL MODULE: ./src/components/UI/Image/index.tsx
var Image = __webpack_require__(51025);
// EXTERNAL MODULE: ./src/components/UI/InlineCta/index.tsx + 1 modules
var InlineCta = __webpack_require__(85499);
// EXTERNAL MODULE: ./src/providers/StyleProvider/index.tsx
var StyleProvider = __webpack_require__(60118);
// EXTERNAL MODULE: ./src/data/dictionary/index.ts + 1 modules
var dictionary = __webpack_require__(9554);
// EXTERNAL MODULE: ./src/components/UI/GridListCard/styles.module.scss
var styles_module = __webpack_require__(56300);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/UI/GridListCard/index.tsx
















var cx = bind_default().bind((styles_module_default()));
var IMAGE_SIZES = [
    {
        layout: "md",
        ratio: 3 / 24
    },
    {
        ratio: 5 / 16
    }
];
function GridListCard(param) {
    var className = param.className, hasReadMore = param.hasReadMore, link = param.link, title = param.title, subtitle = param.subtitle, image = param.image;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useIsHover/* useIsHover */.c)(), 2), isHovered = ref[0], callbacks = ref[1];
    var device = (0,useDeviceType/* useDeviceType */.h)();
    var t = (0,lib/* useTranslate */.qM)();
    var titleStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Title20SangBleuLight */.C.Title20SangBleuLight
    });
    var subtitleStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Label12Grotesk */.C.Label12Grotesk
    });
    var isHovering = device === useDeviceType/* DeviceType.mobile */.Y.mobile ? false : isHovered;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* Link */.r, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, link, callbacks), {
        className: cx((styles_module_default()).GridListCard, className),
        children: [
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, (0,_object_spread/* default */.Z)({
                className: (styles_module_default()).image,
                sizesFromBreakpoints: IMAGE_SIZES,
                ratio: (styles_module_default()).ratio,
                layout: "fill",
                objectFit: "cover",
                asPlaceholder: true
            }, image)),
            (title || subtitle) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).content,
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: cx((styles_module_default()).title, titleStyle),
                        children: title
                    }),
                    subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: cx((styles_module_default()).subtitle, subtitleStyle),
                        children: subtitle
                    }),
                    hasReadMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineCta/* default */.Z, {
                        textPreset: text_preset/* GlobalTextPreset.Cta10Grotesk */.C.Cta10Grotesk,
                        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase,
                        lineProps: {
                            initialLineState: isHovering ? "none" : "underlined",
                            isVisible: !isHovering
                        },
                        className: (styles_module_default()).cta,
                        children: t(dictionary/* CTA.READ_MORE */.MV.READ_MORE)
                    })
                ]
            })
        ]
    }));
}
GridListCard.defaultProps = {};
/* harmony default export */ var UI_GridListCard = (GridListCard);

// EXTERNAL MODULE: ./src/components/UI/Pagination/index.tsx + 1 modules
var Pagination = __webpack_require__(20449);
;// CONCATENATED MODULE: ./src/utils/number-is-odd-or-even.ts
function isOdd(n) {
    return Math.abs(n % 2) == 1;
}
function isEven(n) {
    return n % 2 == 0;
}

// EXTERNAL MODULE: ./src/components/UI/GridList/styles.module.scss
var GridList_styles_module = __webpack_require__(30863);
var GridList_styles_module_default = /*#__PURE__*/__webpack_require__.n(GridList_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/GridList/index.tsx











var GridList_cx = bind_default().bind((GridList_styles_module_default()));
function GridList(_param) {
    var className = _param.className, layout = _param.layout, items = _param.items, hasPagination = _param.hasPagination, hasReadMore = _param.hasReadMore, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "layout",
        "items",
        "hasPagination",
        "hasReadMore"
    ]);
    var maxPage = props.maxPage;
    var needsPagination = hasPagination && maxPage > 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: GridList_cx((GridList_styles_module_default()).GridList, className, (GridList_styles_module_default()) === null || (GridList_styles_module_default()) === void 0 ? void 0 : (GridList_styles_module_default())["layout-".concat(layout)]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: GridList_cx((GridList_styles_module_default()).content),
                children: items === null || items === void 0 ? void 0 : items.map(function(item, index) {
                    var isDesktopLastInRow = index % layout === layout - 1;
                    var isMobileFirstInRow = isEven(index);
                    var isMobileLastInRow = isOdd(index);
                    return /*#__PURE__*/ (0,react.createElement)(UI_GridListCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                        hasReadMore: hasReadMore,
                        className: GridList_cx((GridList_styles_module_default()).item, {
                            isDesktopLastInRow: isDesktopLastInRow,
                            isMobileFirstInRow: isMobileFirstInRow,
                            isMobileLastInRow: isMobileLastInRow
                        }),
                        key: "grid_item_".concat(index)
                    }));
                })
            }),
            needsPagination && /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                className: GridList_cx((GridList_styles_module_default()).pagination),
                maxPage: maxPage
            })
        ]
    });
}
GridList.defaultProps = {
    layout: 4
};
/* harmony default export */ var UI_GridList = (GridList);


/***/ }),

/***/ 64191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _types_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37444);
/* harmony import */ var _types_text_preset__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95348);
/* harmony import */ var _types_text_styling__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36575);
/* harmony import */ var _unlikelystudio_react_slider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7924);
/* harmony import */ var _components_UI_InlineCta__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85499);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39100);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8__);











var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default()));
function GridListNav(param) {
    var className = param.className, links = param.links;
    var customSliderRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)();
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().query;
    var ref;
    var filterValue = (ref = query === null || query === void 0 ? void 0 : query.uid) !== null && ref !== void 0 ? ref : null;
    var isFiltering = !!filterValue;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().GridListNav), className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().wrapper),
            ref: customSliderRef,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_unlikelystudio_react_slider__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().slider)),
                autoIsSlider: true,
                customSliderRef: customSliderRef,
                children: links === null || links === void 0 ? void 0 : links.map(function(link, index) {
                    var isActive = index === 0 ? !isFiltering : filterValue && link.href.toString().indexOf("".concat(filterValue)) > -1;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_InlineCta__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().link), {
                            isActive: isActive
                        }),
                        textPreset: _types_text_preset__WEBPACK_IMPORTED_MODULE_5__/* .GlobalTextPreset.Cta12Grotesk */ .C.Cta12Grotesk,
                        textStyling: _types_text_styling__WEBPACK_IMPORTED_MODULE_6__/* .GlobalTextStyling.UpperCase */ .l.UpperCase,
                        theme: isActive ? _types_colors__WEBPACK_IMPORTED_MODULE_4__/* .GlobalThemeColors.Black */ .b.Black : _types_colors__WEBPACK_IMPORTED_MODULE_4__/* .GlobalThemeColors.SilverChalice */ .b.SilverChalice,
                        lineProps: {
                            initialLineState: isActive ? "underlined" : "none"
                        }
                    }, link), "link_right_".concat(index));
                })
            })
        })
    });
}
GridListNav.defaultProps = {};
/* harmony default export */ __webpack_exports__["Z"] = (GridListNav);


/***/ }),

/***/ 49035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _types_grid_preset__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31538);
/* harmony import */ var _types_text_preset__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95348);
/* harmony import */ var _components_UI_GridListNav__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64191);
/* harmony import */ var _providers_StyleProvider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60118);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23802);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_7__);








var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default()));
function HeroGridList(param) {
    var className = param.className, childrenClassName = param.childrenClassName, title = param.title, links = param.links, children = param.children;
    var gridStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_6__/* .useStyle */ .X)({
        grid: _types_grid_preset__WEBPACK_IMPORTED_MODULE_3__/* .GlobalGridPreset.BASE_GRID */ .H.BASE_GRID
    });
    var titleStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_6__/* .useStyle */ .X)({
        textPreset: _types_text_preset__WEBPACK_IMPORTED_MODULE_4__/* .GlobalTextPreset.Title40SangBleu */ .C.Title40SangBleu
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().HeroGridList), className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().content), gridStyle),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().left),
                    children: title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().title), titleStyle),
                        children: title
                    })
                }),
                children && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().center), childrenClassName),
                    children: children
                }),
                (links === null || links === void 0 ? void 0 : links.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().right),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_GridListNav__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        links: links,
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().links)
                    })
                })
            ]
        })
    });
}
HeroGridList.defaultProps = {};
/* harmony default export */ __webpack_exports__["Z"] = (HeroGridList);


/***/ }),

/***/ 20449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UI_Pagination; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./src/@types/grid-preset.ts
var grid_preset = __webpack_require__(31538);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@types/breakpoints.ts
var breakpoints = __webpack_require__(59646);
// EXTERNAL MODULE: ./src/@types/colors.ts
var colors = __webpack_require__(37444);
// EXTERNAL MODULE: ./src/@types/text-preset.ts
var text_preset = __webpack_require__(95348);
// EXTERNAL MODULE: ./src/@types/text-styling.ts
var text_styling = __webpack_require__(36575);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-slider/dist/es/hooks/useSliderState/index.js
var useSliderState = __webpack_require__(80581);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-slider/dist/es/index.js + 19 modules
var es = __webpack_require__(7924);
// EXTERNAL MODULE: ./src/components/Abstracts/Icons/index.tsx + 15 modules
var Icons = __webpack_require__(1815);
// EXTERNAL MODULE: ./src/providers/FilterProvider/index.tsx
var FilterProvider = __webpack_require__(42193);
// EXTERNAL MODULE: ./src/providers/PaginationProvider/index.tsx
var PaginationProvider = __webpack_require__(49981);
// EXTERNAL MODULE: ./src/providers/StyleProvider/index.tsx
var StyleProvider = __webpack_require__(60118);
// EXTERNAL MODULE: ./src/hooks/useBreakpoint/index.ts + 4 modules
var useBreakpoint = __webpack_require__(7695);
// EXTERNAL MODULE: ./src/hooks/useLocale/index.ts
var useLocale = __webpack_require__(66794);
// EXTERNAL MODULE: ./src/components/Abstracts/Pagination/styles.module.scss
var styles_module = __webpack_require__(14699);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/Abstracts/Pagination/index.tsx



















var cx = bind_default().bind((styles_module_default()));
var ITEMS_LENGTH_DESKTOP = 15;
var ITEMS_LENGTH_MOBILE = 10;
function Pagination(param) {
    var className = param.className, maxPage = param.maxPage;
    var ref;
    var router = (0,next_router.useRouter)();
    var locale = (0,useLocale/* default */.Z)();
    var ref1 = (0,PaginationProvider/* usePagination */.h0)(), currentPage = ref1.currentPage, getRouterParams = ref1.getRouterParams;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useSliderState/* default */.Z)(), 2), ref3 = ref2[0], setSlideIndex = ref3.setSlideIndex, slideIndex = ref3.slideIndex, nextSlide = ref3.nextSlide, prevSlide = ref3.prevSlide, setSliderState = ref2[1];
    var ref4 = (0,react.useState)(), initialIndex = ref4[0], setInitialIndex = ref4[1];
    var ref5 = (0,react.useState)(ITEMS_LENGTH_DESKTOP), itemsVisible = ref5[0], setItemsVisible = ref5[1];
    var userFiltering = (0,FilterProvider/* useFilter */.L0)().userFiltering;
    var customSliderRef = (0,react.useRef)();
    var slidedIndex = (0,react.useRef)(initialIndex);
    var isMobile = (0,useBreakpoint/* default */.Z)(breakpoints/* GLOBAL_BREAKPOINTS.MD */.L.MD);
    var maxIndex = maxPage - itemsVisible;
    var linkStyle = (0,StyleProvider/* useStyle */.X)({
        color: colors/* GlobalThemeColors.Black */.b.Black,
        textPreset: text_preset/* GlobalTextPreset.Cta12GroteskRegular */.C.Cta12GroteskRegular,
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase
    });
    (0,react.useEffect)(function() {
        isMobile ? setItemsVisible(ITEMS_LENGTH_MOBILE) : setItemsVisible(ITEMS_LENGTH_DESKTOP);
    }, [
        isMobile
    ]);
    (0,react.useEffect)(function() {
        if (currentPage < 2) setInitialIndex(0);
        else if (currentPage > maxIndex) setInitialIndex(maxIndex);
        else setInitialIndex(currentPage - 3);
    }, [
        currentPage,
        maxIndex
    ]);
    (0,react.useEffect)(function() {
        if (initialIndex !== slideIndex) {
            setSlideIndex(initialIndex);
        }
    }, [
        initialIndex
    ]);
    var renderLink = function(value) {
        // Get router params and pass page value
        var params = getRouterParams(value);
        return Boolean(value) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            prefetch: false,
            // We are using an href so this is not a shallow push
            onClick: function(e) {
                e.preventDefault();
                router.push(params, undefined, {
                    shallow: true,
                    locale: locale
                });
            },
            href: params,
            shallow: userFiltering,
            locale: locale,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: cx((styles_module_default()).link, currentPage === value && (styles_module_default()).active, linkStyle),
                children: value
            })
        }, value);
    };
    var renderArrow = function(orientation) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: cx((styles_module_default()).arrow, (styles_module_default())[orientation]),
            onClick: function() {
                return orientation === "left" ? prevSlide() : nextSlide();
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ArrowLeftIcon */.Y4, {
                className: (styles_module_default()).icon
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (styles_module_default()).sliderContainer,
            style: {
                width: 24 * itemsVisible
            },
            children: [
                slideIndex > 0 && renderArrow("left"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.ZP, {
                    className: cx((styles_module_default()).slider),
                    setSliderState: setSliderState,
                    initialSlideIndex: initialIndex,
                    snap: true,
                    autoBlockSlideIndexChange: true,
                    ref: customSliderRef,
                    onSlideIndexChange: function(index) {
                        return slidedIndex.current = index;
                    },
                    children: (ref = (0,_to_consumable_array/* default */.Z)(Array(maxPage + 1))) === null || ref === void 0 ? void 0 : ref.map(function(_, index) {
                        return renderLink(index);
                    })
                }),
                slideIndex < maxIndex && renderArrow("right")
            ]
        })
    });
}
Pagination.defaultProps = {};
/* harmony default export */ var Abstracts_Pagination = (Pagination);

// EXTERNAL MODULE: ./src/components/UI/Pagination/styles.module.scss
var Pagination_styles_module = __webpack_require__(29196);
var Pagination_styles_module_default = /*#__PURE__*/__webpack_require__.n(Pagination_styles_module);
;// CONCATENATED MODULE: ./src/components/UI/Pagination/index.tsx








var Pagination_cx = bind_default().bind((Pagination_styles_module_default()));
function Pagination_Pagination(_param) {
    var className = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    var gridStyle = (0,StyleProvider/* useStyle */.X)({
        grid: grid_preset/* GlobalGridPreset.BASE_GRID */.H.BASE_GRID
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: Pagination_cx((Pagination_styles_module_default()).Pagination, className, gridStyle),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Abstracts_Pagination, (0,_object_spread/* default */.Z)({
            className: Pagination_cx((Pagination_styles_module_default()).content)
        }, rest))
    });
}
Pagination_Pagination.defaultProps = {};
/* harmony default export */ var UI_Pagination = (Pagination_Pagination);


/***/ }),

/***/ 14699:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sliderContainer":"styles_sliderContainer__vxeEy","arrow":"styles_arrow__BnMkU","left":"styles_left___lXTo","icon":"styles_icon__7MwCV","right":"styles_right__sp9Pq","slider":"styles_slider__n02c6","link":"styles_link__msTqa","active":"styles_active__Jdkgc"};

/***/ }),

/***/ 30863:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"GridList":"styles_GridList___vGJg","content":"styles_content__AWOYG","item":"styles_item___KdDT","isMobileFirstInRow":"styles_isMobileFirstInRow__5Xp1j","isMobileLastInRow":"styles_isMobileLastInRow__9KYN_","isDesktopLastInRow":"styles_isDesktopLastInRow__IUoiK","pagination":"styles_pagination__nUqPz","layout-4":"styles_layout-4__QqAuJ","layout-6":"styles_layout-6__QE60i"};

/***/ }),

/***/ 56300:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"GridListCard":"styles_GridListCard__vYfN4","image":"styles_image__TNXk_","ratio":"styles_ratio__k2A3n","content":"styles_content__KbmIx","title":"styles_title__HoqnW","cta":"styles_cta__cuNlC"};

/***/ }),

/***/ 39100:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"GridListNav":"styles_GridListNav__rev1H","wrapper":"styles_wrapper__VrbkE","link":"styles_link__T7U1A","isActive":"styles_isActive__VkD6a"};

/***/ }),

/***/ 23802:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"HeroGridList":"styles_HeroGridList__YyXXf","left":"styles_left__rxXZh","right":"styles_right__kHznY","center":"styles_center__A96yO"};

/***/ }),

/***/ 29196:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Pagination":"styles_Pagination__illu0","content":"styles_content__IyxbP"};

/***/ })

}]);